module.exports = __webpack_public_path__ + "static/military-yellow-a24e889324b863a0d09ed0a8d7fcdb85.svg";